@if (!balancePerMerchant || this.financeService.getSelectedMerchant()) {
    <prl-add-payment-request></prl-add-payment-request>
} @else {
    <mx-grid (customize)='onCustomize($event)'></mx-grid>
}